import { render, staticRenderFns } from "./DumbappForm.vue?vue&type=template&id=4cb86ac3&scoped=true&"
import script from "./DumbappForm.vue?vue&type=script&lang=ts&"
export * from "./DumbappForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb86ac3",
  null
  
)

export default component.exports